import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './main.css';
import Home from './pages/home';
import ConfirmationPage from './pages/confirmation';
import VerifyPage from './pages/verify';

function EnvBanner() {
  const env = process.env.REACT_APP_ENV;
  if (!env || env.toLowerCase() === 'prod') return null;
  const apiUrl = process.env.REACT_APP_API_URL || '(not set)';
  const colors = { local: '#4ade80', dev: '#facc15', development: '#facc15', staging: '#f97316' };
  const accent = colors[env.toLowerCase()] || '#facc15';
  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 9999,
      background: '#1a1a1a', borderTop: `2px solid ${accent}`,
      color: '#ccc', fontSize: '0.7rem', padding: '4px 12px',
      display: 'flex', gap: '12px', alignItems: 'center',
      fontFamily: 'monospace',
    }}>
      <span style={{ fontWeight: 700, textTransform: 'uppercase', color: accent }}>
        {env}
      </span>
      <span style={{ color: '#888' }}>|</span>
      <span>API: {apiUrl}</span>
    </div>
  );
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
     <BrowserRouter>
      <EnvBanner />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/confirmation" element={<ConfirmationPage />} />
        <Route path="/verify" element={<VerifyPage />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

